var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickUniversal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50401 0.317383C14.5773 0.317383 18.6916 4.4317 18.6916 9.50498C18.6916 14.5783 14.5773 18.6926 9.50401 18.6926C4.43073 18.6926 0.316406 14.5783 0.316406 9.50498C0.316406 4.4317 4.43073 0.317383 9.50401 0.317383ZM7.59609 12.4892L5.34674 10.238C4.96353 9.85453 4.96345 9.22925 5.34674 8.84589C5.73011 8.4626 6.35817 8.465 6.73875 8.84589L8.32453 10.4329L12.2694 6.48803C12.6528 6.10466 13.2781 6.10466 13.6614 6.48803C14.0448 6.87132 14.0442 7.49721 13.6614 7.88004L9.01941 12.5221C8.63659 12.9049 8.01069 12.9054 7.6274 12.5221C7.61663 12.5113 7.60624 12.5003 7.59609 12.4892Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickUniversal);
export default __webpack_public_path__ + "static/media/TickUniversal.d2dda787ee50623bf7b638535edde741.svg";
export { ForwardRef as ReactComponent };